
import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'BSwitch',
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const updatedValue = ref(props.value)

    function toggleSwitch() {
      updatedValue.value = !updatedValue.value
      emit('switch', updatedValue.value)
    }

    return {
      updatedValue,
      toggleSwitch,
    }
  },
})
